'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Link$PvpcontrollerWeb = require("./Link.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var WeaponModel$PvpcontrollerWeb = require("../models/WeaponModel.js");

var cardHover = Css.hover({
      hd: Css.cursor(Css.pointer),
      tl: {
        hd: Css.backgroundColor(Css.hex("3c4046")),
        tl: /* [] */0
      }
    });

var baseCard_0 = Css.maxWidth(Css.px(305));

var baseCard_1 = {
  hd: Css.padding(Css.px(5)),
  tl: {
    hd: Css.margin(Css.px(5)),
    tl: {
      hd: Css.border(Css.px(1), Css.solid, Css.hex("393c42")),
      tl: {
        hd: Css.width(Css.px(300)),
        tl: {
          hd: Css.height(Css.px(150)),
          tl: {
            hd: Css.position(Css.relative),
            tl: {
              hd: Css.backgroundColor(Css.hex("3c4046")),
              tl: {
                hd: Css.borderRadius(Css.px(3)),
                tl: {
                  hd: Css.flex3(1.0, 0.0, "auto"),
                  tl: {
                    hd: Css.unsafe("boxShadow", "0px 0px 12px -1px rgb(40 43 47)"),
                    tl: {
                      hd: cardHover,
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

var baseCard = {
  hd: baseCard_0,
  tl: baseCard_1
};

var card = Curry._1(Css.style, baseCard);

var gradient = Curry._1(Css.keyframes, {
      hd: [
        0,
        {
          hd: Css.backgroundPosition4("left", {
                NAME: "percent",
                VAL: 0.0
              }, "top", {
                NAME: "percent",
                VAL: 50.0
              }),
          tl: /* [] */0
        }
      ],
      tl: {
        hd: [
          50,
          {
            hd: Css.backgroundPosition4("left", {
                  NAME: "percent",
                  VAL: 100.0
                }, "top", {
                  NAME: "percent",
                  VAL: 50.0
                }),
            tl: /* [] */0
          }
        ],
        tl: {
          hd: [
            100,
            {
              hd: Css.backgroundPosition4("left", {
                    NAME: "percent",
                    VAL: 0.0
                  }, "top", {
                    NAME: "percent",
                    VAL: 50.0
                  }),
              tl: /* [] */0
            }
          ],
          tl: /* [] */0
        }
      }
    });

var fakeCard = Curry._1(Css.style, List.concat({
          hd: baseCard,
          tl: {
            hd: {
              hd: Css.background(Css.linearGradient(Css.deg(-45.0), [
                        [
                          {
                            NAME: "percent",
                            VAL: 0.0
                          },
                          {
                            NAME: "hex",
                            VAL: "3c4046"
                          }
                        ],
                        [
                          {
                            NAME: "percent",
                            VAL: 33.0
                          },
                          {
                            NAME: "hex",
                            VAL: "3c4046"
                          }
                        ],
                        [
                          {
                            NAME: "percent",
                            VAL: 66.0
                          },
                          {
                            NAME: "hex",
                            VAL: "363b42"
                          }
                        ],
                        [
                          {
                            NAME: "percent",
                            VAL: 100.0
                          },
                          {
                            NAME: "hex",
                            VAL: "3c4046"
                          }
                        ]
                      ])),
              tl: {
                hd: Css.backgroundSize({
                      NAME: "size",
                      VAL: [
                        {
                          NAME: "percent",
                          VAL: 400.0
                        },
                        {
                          NAME: "percent",
                          VAL: 400.0
                        }
                      ]
                    }),
                tl: {
                  hd: Css.animation(3000, undefined, undefined, "ease", undefined, undefined, "infinite", gradient),
                  tl: /* [] */0
                }
              }
            },
            tl: /* [] */0
          }
        }));

var name = Curry._1(Css.style, {
      hd: Css.marginLeft(Css.px(5)),
      tl: {
        hd: Css.color(Theme$PvpcontrollerWeb.subTitleColor),
        tl: {
          hd: Css.fontSize(Css.px(18)),
          tl: /* [] */0
        }
      }
    });

var image = Curry._1(Css.style, {
      hd: Css.position(Css.absolute),
      tl: {
        hd: Css.bottom(Css.px(45)),
        tl: {
          hd: Css.right(Css.px(25)),
          tl: /* [] */0
        }
      }
    });

var detailsHover = Css.hover({
      hd: Css.color(Css.hex("ffffff")),
      tl: /* [] */0
    });

var details = Curry._1(Css.style, {
      hd: Css.color(Css.hex("aaaaaa")),
      tl: {
        hd: Css.fontSize(Css.px(15)),
        tl: {
          hd: Css.position(Css.absolute),
          tl: {
            hd: Css.bottom(Css.px(10)),
            tl: {
              hd: Css.right(Css.px(10)),
              tl: {
                hd: detailsHover,
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var category = Curry._1(Css.style, {
      hd: Css.color(Css.hex("cccccc")),
      tl: {
        hd: Css.fontSize(Css.px(15)),
        tl: {
          hd: Css.position(Css.absolute),
          tl: {
            hd: Css.bottom(Css.px(10)),
            tl: {
              hd: Css.left(Css.px(10)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var categoryName = Curry._1(Css.style, {
      hd: Css.textTransform(Css.capitalize),
      tl: /* [] */0
    });

var meleeBackground = Curry._1(Css.style, {
      hd: Css.hover({
            hd: Css.backgroundColor(Css.hex("50473c")),
            tl: /* [] */0
          }),
      tl: /* [] */0
    });

var magicBackground = Curry._1(Css.style, {
      hd: Css.hover({
            hd: Css.backgroundColor(Css.hex("473d4a")),
            tl: /* [] */0
          }),
      tl: /* [] */0
    });

var rangedBackground = Curry._1(Css.style, {
      hd: Css.hover({
            hd: Css.backgroundColor(Css.hex("4a3838")),
            tl: /* [] */0
          }),
      tl: /* [] */0
    });

var summonerBackground = Curry._1(Css.style, {
      hd: Css.hover({
            hd: Css.backgroundColor(Css.hex("474837")),
            tl: /* [] */0
          }),
      tl: /* [] */0
    });

var dmg = Curry._1(Css.style, {
      hd: Css.color(Css.hex("848484")),
      tl: /* [] */0
    });

function WeaponCard$Fake(Props) {
  return React.createElement(Link$PvpcontrollerWeb.make, Link$PvpcontrollerWeb.makeProps("#", fakeCard, React.createElement("div", undefined), undefined, undefined, undefined, undefined));
}

function WeaponCard(Props) {
  var weapon = Props.weapon;
  var match = weapon.category;
  var backgroundClass;
  switch (match) {
    case /* Melee */0 :
        backgroundClass = meleeBackground;
        break;
    case /* Magic */1 :
        backgroundClass = magicBackground;
        break;
    case /* Ranged */2 :
        backgroundClass = rangedBackground;
        break;
    case /* Summoner */3 :
        backgroundClass = summonerBackground;
        break;
    
  }
  var category$1 = WeaponModel$PvpcontrollerWeb.categoryToString(weapon.category);
  var cardStyle = Curry._1(Css.merge, {
        hd: card,
        tl: {
          hd: backgroundClass,
          tl: /* [] */0
        }
      });
  return React.createElement(Link$PvpcontrollerWeb.make, Link$PvpcontrollerWeb.makeProps("/weapon/" + String(weapon.netId), cardStyle, React.createElement("div", undefined, React.createElement("div", {
                          className: name
                        }, weapon.name), React.createElement("img", {
                          className: image,
                          src: weapon.image
                        }), React.createElement("div", {
                          className: category
                        }, React.createElement("span", {
                              className: categoryName + " " + Theme$PvpcontrollerWeb.forCategory(weapon.category)
                            }, category$1)), React.createElement("div", {
                          className: details
                        }, String(weapon.damage) + " ", React.createElement("span", {
                              className: dmg
                            }, "dmg"))), undefined, undefined, undefined, undefined));
}

function Fake_makeProps(prim0, prim1) {
  var tmp = {};
  if (prim0 !== undefined) {
    tmp.key = prim0;
  }
  return tmp;
}

var Fake = {
  makeProps: Fake_makeProps,
  make: WeaponCard$Fake
};

function makeProps(prim0, prim1, prim2) {
  var tmp = {
    weapon: prim0
  };
  if (prim1 !== undefined) {
    tmp.key = prim1;
  }
  return tmp;
}

var make = WeaponCard;

exports.Fake = Fake;
exports.makeProps = makeProps;
exports.make = make;
/* cardHover Not a pure module */
